import {DiscordUrl, TwitterUrl, TelegramUrl, MediumUrl, RedditUrl, YoutubeUrl} from "../constants";

import socialIconsTelegram from '../assets/icons/social/telegram.svg';
import socialIconsTwitter from '../assets/icons/social/twitter.svg';
import socialIconsDiscord from '../assets/icons/social/discord.svg';
import socialIconsMedium from '../assets/icons/social/medium.svg';
import socialIconsReddit from '../assets/icons/social/reddit.svg';
import socialIconsYoutube from '../assets/icons/social/youtube.svg';
import classNames from "classnames";

export const SocialIcons = ({className}) => {
    return (
        <div className={classNames(['SocialIcons', className])}>
            <SocialIcon icon={socialIconsTelegram}
                        href={TelegramUrl}
            />
            <SocialIcon icon={socialIconsTwitter}
                        href={TwitterUrl}
            />
            <SocialIcon icon={socialIconsYoutube}
                        href={YoutubeUrl}
            />
            <SocialIcon icon={socialIconsDiscord}
                        href={DiscordUrl}
            />
            <SocialIcon icon={socialIconsReddit}
                        href={RedditUrl}
            />
            <SocialIcon icon={socialIconsMedium}
                        href={MediumUrl}
            />
        </div>
    );
}

export const SocialIcon = ({icon, href}) => {
    return (
        <a href={href}
           target={'_blank'}
           className={'SocialIcon'}
        >
            <img src={icon}/>
        </a>
    );
}

export default SocialIcons;